var map = {
	"./hackathons/datasetJson/logo.png": 55235,
	"./hackathons/datasetJsonViewer/logo.png": 77245,
	"./projects/CDISC-Library-Client/logo.png": 51619,
	"./projects/CDISC-ODM-XML-CRF-SDTM-Annotations/logo.png": 44656,
	"./projects/R4DSXML/logo.png": 317,
	"./projects/SDW/logo.png": 93425,
	"./projects/admiral/logo.png": 40219,
	"./projects/cards/logo.png": 30234,
	"./projects/cardx/logo.png": 85167,
	"./projects/carver/logo.png": 21010,
	"./projects/core/logo.png": 91538,
	"./projects/coreRuleEditor/logo.png": 66261,
	"./projects/dataset-json-r-implementation/logo.png": 7766,
	"./projects/dataset-json-sas-implementation/logo.png": 76083,
	"./projects/ddf/logo.png": 58439,
	"./projects/defineR/logo.png": 65806,
	"./projects/defineStylesheets/logo.png": 99493,
	"./projects/gtsummary/logo.png": 90972,
	"./projects/handyct/logo.png": 12706,
	"./projects/odm-xml-stylesheet/logo.png": 44740,
	"./projects/odmlib/logo.png": 58608,
	"./projects/open-sas-clinical-standards-toolkit/logo.png": 78831,
	"./projects/openStudyBuilder/logo.png": 51601,
	"./projects/ramnog/logo.png": 20721,
	"./projects/sdtm.oak/logo.png": 47538,
	"./projects/siera/logo.png": 4799,
	"./projects/smartSubmissionDatasetViewer/logo.png": 2448,
	"./projects/tfrmt/logo.png": 21692,
	"./projects/tidycdisc/logo.png": 25537,
	"./projects/tplyr/logo.png": 13718,
	"./projects/vde/logo.png": 16964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77497;